import { primaryTabType } from "./types"

export const primaryTabs: primaryTabType = {
  clinical: "Clinical Hours",
  nonClinical: "Non Clinical Hours",
}

export const secondayTabs = {
  doctors: "Doctors",
  hygienists: "Hygienists",
}

export const filters = {
  offices: "offices",
  regions: "regions",
  groups: "groups",
}

export const filterLabels: any = {
  Groups: "Group Name",
  Regions: "Regions",
  Offices: "Offices",
  Year: "Year",
}

export const pnlFilters: any = {
  maevaGroups: "Group Name",
  maevaRegions: "Regions",
  maevaPractices: "Offices",
}
